
import { Injectable } from '@angular/core';
import ApiResponse from 'models/api-response/api-response.model';
import GeoJSONPoint from 'models/geojson-point/geojson-point.model';
import Log from 'models/log/log.model';
import { ApiRequestService } from 'services/api-request/api-request.service';
import { LogService } from 'services/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class GeoCodeService {
 
  constructor(
    public apiRequestService: ApiRequestService,
    public logService: LogService,
  ) { }

  public async getAddressHints(searchText: string): Promise<GeoJSONPoint<any>[]> {
    return new Promise((resolve: (r: GeoJSONPoint<any>[]) => any, reject: (e: Error) => any) => {
        this.apiRequestService.get('/geocode/hints?address=' + encodeURI(searchText)).subscribe({
          next: async (res: ApiResponse<any>) => {
              if (!res.success) {
                  await this.logService.create(new Log({
                      description: 'requestError: ' + JSON.stringify(res),
                      event: 'serviceError',
                      performer: 'GeoCodeService.getAddressHints',
                      type: 'error'
                    }));
                  return reject(new Error('requestError'));
              }
              let hints: GeoJSONPoint<any>[] = [];
              for (let i = 0; i < res.data.address.length; i++) {
                hints.push(new GeoJSONPoint(res.data.address[i]));
              }
              return resolve(hints);
          },
          error: async error => {
            console.log(error);
            await this.logService.create(new Log({
              description: error,
              event: 'serviceError',
              performer: 'GeoCodeService.getAddressHints',
              type: 'error'
            }));
            return reject(new Error('requestError'));
          }
        });
    });
  }
}
